<template>
	<div class="position-absolute d-flex gap-2 top-0 end-0 mt-2 me-2">
		<div class="btn-group" role="group">
			<button type="button" class="btn dropdown-toggle" :class="{'btn-light': !authModel.isAuth(), 'btn-outline-secondary': authModel.isAuth()}" data-bs-toggle="dropdown" aria-expanded="false">
				{{appModel.getLang().toUpperCase()}}
			</button>
			<ul class="dropdown-menu">
				<li v-for="(langname, langkey) in appModel.langsName" :key="'lang-'+langkey">
					<a class="dropdown-item" :class="{'active': langkey == appModel.getLang()}" href="javascript://" @click="appModel.setLang(langkey)">{{langname}}</a>
				</li>
			</ul>
		</div>
		<router-link :to="{path: '/logout'}" class="btn btn-outline-secondary" v-if="authModel.isAuth()">{{$t('btn.logout')}}</router-link>
	</div>
	<router-view/>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'KMIB EDU'});
	},
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	mounted(){},
	components: {},
}
</script>